
// 'use strict'
import globalConfig from '../config/global-variables'

var log = {
    getCurrentStack: () => {
        const error = new Error("StackLog");
        const stackTraceLines = error.stack.split('\n');
        if (stackTraceLines.length >= 4) {
            const stackLine = stackTraceLines[3].trim();
            return stackLine
            // const funcName = stackLine.substring(0, stackLine.indexOf('('));
            // const lineNumber = stackLine.substring(stackLine.lastIndexOf('/') + 1).replace(')', '');
            // return [funcName, lineNumber, stackLine];
            // //return stackLine.match(/(?:https?:\/\/[^\s\/]*\/|\/)[^\s:]+:\d+/)[0].split(':');               
          }
          return ['',0];
    },
    getStack: () => {
        let arrST = (new Error("StackLog")).stack.split("\n").slice(3, 6).reverse(); //arrST //.slice(0,5);
        let result = ''
        for (let i = 0; i < arrST.length; i++) {
            // var caller_line = arrST[i];//err.stack.split("\n")[4];
            // var index = caller_line.indexOf("at ");
            // var clean = caller_line.slice(index + 2, caller_line.length);
            let s = arrST[i].split('at')[1].trim();
            let funcName = s.substring(0, s.indexOf('('));
            let fileName = s.substring(s.lastIndexOf('/') + 1).replace(')', '');
            result = result.concat(`${funcName}(${fileName}) > `);
        }
        return result;
        // var obj = {};
        //   Error.captureStackTrace(obj, getStackTrace);
        //   return obj.stack;
    },
    /**
     * log with stacktrace - console.trace(-)
     * @param {*} obj 
     * @param {*} withST 
     */
    i: (msg, obj='') => {
        if (globalConfig.debug) {
            console.trace("%c" + msg + ": %o", "color: cyan;", obj, `                   -> ${log.getCurrentStack()}`)
            // console.trace();
        } else {
            console.log('prod version');
        }
    },
    /**
     * log simple - console.log(-)
     * @param {*} msg 
     * @param {*} obj 
     */
    p: (msg, obj='') => {
        if (globalConfig.debug) {
            // const stackLine = log.getCurrentStack();
            console.log("%c" + msg + ": %o", "color: green;", obj, `                   -> ${log.getCurrentStack()}`)
        } else {
            console.log('prod version');
        }
    },
    /**
     * log as warning - console.warn(-)
     * @param {*} obj  
     * @param {*} withST 
     */
    w: (msg,obj) => {
        if (globalConfig.debug) {            
            // console.warn("%c" + obj + ": %o", "color: orange;")
            console.warn("%c" + msg + ": %o", "color: orange;", obj, `                   -> ${log.getCurrentStack()}`)
        } else {
            console.log('prod version');
        }
    },
    /**
     * log as error - console.error(-)
     * @param {*} obj 
     * @param {*} withST 
     */
    e: (msg, err) => {
        if (globalConfig.debug) {
            console.error("%c" + msg + ": %o", "color: red;", err, `                   -> ${log.getCurrentStack()}`)
            // console.error("%c" + st + ": %o", "color: green;", obj)
        } else {
            console.log('prod version');
        }
    },
    /**
     * log string as stdout console.dir(-)
     * @param {*} obj 
     * @param {*} withST 
     */
    d: (obj, withST) => {
        if (globalConfig.debug) {
            let st = ''
            if (withST) st = log.getStack();
            console.dir("%c" + st + ": %o", "color: orange;", obj)
        } else {
            console.log('prod version');
        }
    },
    /**
     * log array as formatted table - console.table(-)
     * @param {*} table 
     */
    t: (table) => {
        if (globalConfig.debug) {
            console.table(table);
        } else {
            console.log('prod version');
        }
    },

}
export default log;